import { v4 as uuidv4 } from 'uuid';

export const listKeyGenerator = (listLength) => {
    return Array.from({ length: listLength }, () => uuidv4());
};